import { render, staticRenderFns } from "./HumanCapitalAccidentsCountInput.vue?vue&type=template&id=659cf2ae&scoped=true&"
import script from "./HumanCapitalAccidentsCountInput.vue?vue&type=script&lang=js&"
export * from "./HumanCapitalAccidentsCountInput.vue?vue&type=script&lang=js&"
import style0 from "./HumanCapitalAccidentsCountInput.vue?vue&type=style&index=0&id=659cf2ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659cf2ae",
  null
  
)

export default component.exports